import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from 'moment-timezone';

import { posAnalyticsApi, clearPosDataList, selectAllPosData } from "../reducers/posAnalyticsSlice";
import { PosAnalyticsModel } from "../models/PosAnalyticsModel";

import { Row, Col, Card, CardBody } from "reactstrap";
import PosDataFilter from "./pos/PosDataFilter";
import PosAnalytics from "./pos/PosAnalytics";
import AnalyticsPopup from "./pos/AnalyticsPopup";
import PosDataTrackTable from "./pos/PosDataTrackTable";

const Analytics = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [trackList, setTrackList] = useState([]);
    const [series, setSeries] = useState([])
    const [trackCol, setTrackCol] = useState(4)

    const posData = useSelector((state) => selectAllPosData(state));
    const fromDate = useSelector((state) => state.posAnalyticsReducer.fromDate);
    const toDate = useSelector((state) => state.posAnalyticsReducer.toDate);
    const groupBy = useSelector((state) => state.posAnalyticsReducer.groupBy);

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(clearPosDataList())
        
        let name = "Tutti"
        let filter = {
            pos_id: null,
            area_id: null,
            template_id: null,
            sign: null,
            group: null,
        }

        onNewAnalytics(name, filter)
    }, [dispatch])

    // console.log('trackList', trackList)
    
    useEffect(() => {
        trackList.forEach((track) => {
            dispatch(clearPosDataList())
            
            let from = fromDate ? moment.tz(fromDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
            let to = toDate ? moment.tz(toDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
        
            dispatch(posAnalyticsApi.fetchAll({
                name: track.name,
                type: PosAnalyticsModel.TYPE_AVG_SCORE,
                group: groupBy,
                fromDate: from,
                toDate: to,
                filters: track.filter
            }))
        })
    }, [dispatch, trackList, fromDate, toDate, groupBy])

    useEffect(() => {
        let nameSerie = null
        let wrappedSeries = []
        let data = []
    
        posData.forEach((entity) => {
            if(nameSerie !== entity.name && nameSerie !== null) {
                wrappedSeries.push({
                    name: nameSerie,
                    data: data
                })
                nameSerie = entity.name
                data = []
            } else {
                nameSerie = entity.name
            }
            data.push(entity)
        })
    
        if(nameSerie && data.length > 0) {
            wrappedSeries.push({
              name: nameSerie,
              data: data
            })
        
        }
        // console.log("wrappedSeries", wrappedSeries)
        setSeries(wrappedSeries)
        wrappedSeries.length < 3 ? setTrackCol(12 / wrappedSeries.length) : setTrackCol(4)
      }, [dispatch, posData])

    const onNewAnalytics = (name, filter) => {
        // let name = "Tracciato "+(trackList.length+1)
        
        let from = fromDate ? moment.tz(fromDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
        let to = toDate ? moment.tz(toDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
        
        let match = trackList.find((track) => (
            track.filter.pos_id === filter.pos_id &&
            track.filter.area_id === filter.area_id &&
            track.filter.template_id === filter.template_id &&
            track.filter.sign === filter.sign &&
            track.filter.group === filter.group
        ))

        if(!match || !match.data) {
            dispatch(posAnalyticsApi.fetchAll({
                name: name,
                type: PosAnalyticsModel.TYPE_AVG_SCORE,
                group: groupBy,
                fromDate: from,
                toDate: to,
                filters: filter
            }))
            trackList.push({ name: name, filter: filter})
            setTrackList(trackList)
        }
    } 

    return <div className="app-drawer">
        <Row>
          <Col md="12"><h1>Analytics</h1></Col>
        </Row>
        <PosDataFilter 
            addButton={true} 
            onAddClick={() => { setShowPopup(true) }} 
            groupByModes={[
                {value: PosAnalyticsModel.GROUP_DAILY, label: "giornaliero"},
                {value: PosAnalyticsModel.GROUP_MONTHLY, label: "mensile"},
                {value: PosAnalyticsModel.GROUP_YEARLY, label: "annuale"},
            ]}
        />
        <Row>
            <Col md="12">
                <Card>
                    <CardBody>
                        <Row className="p-4">
                            <Col md="12" className="text-left">
                            <PosAnalytics 
                                colors={[]}
                                width="100%"
                                height="300"
                            />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
        <Row>
            {series.map((serie) => (
                <Col xs="12" md={trackCol} key={serie.name} >
                    <PosDataTrackTable serie={serie} />
                </Col>
            ))}
        </Row>
        { 
            showPopup
                ? <AnalyticsPopup onToggle={() => { setShowPopup(false) }} onNewAnalytics={onNewAnalytics}/>
                : null
        }
    </div>
};

export default Analytics;